import { CAUI } from './ca-ui.js';
import { DropdownButton } from './dropdown-button.js';

export class IconSelect extends DropdownButton {
  static defaultOptions = {
    componentName: 'IconSelect',
    icon: 'smile',
    dropDown: { width: 660, maxHeight: 400 }
  };

  static icons = null;

  constructor (options) {
    super(
      IconSelect.initOptions($.extend({}, IconSelect.defaultOptions, options))
    );
    this.activeItem = null;

    // search box
    this.searchbox = $(
      '<input class="ca-vr-assetselect_search" type="input" placeholder="Search..." maxlength="100" />'
    );

    this.searchbox.on(
      'input',
      function () {
        this.filterAssets(this.searchbox.val());
      }.bind(this)
    );

    this.dropDown.el.append(this.searchbox);

    // Common
    this.commonLabel = $('<label>Common icons</label>');
    this.dropDown.add(this.commonLabel);

    this.commonList = $('<ul></ul>');
    this.dropDown.add(this.commonList);

    // All
    this.allLabel = $('<label style="margin-top:20px">All icons</label>');
    this.dropDown.add(this.allLabel);

    this.allList = $('<ul></ul>');
    this.dropDown.add(this.allList);

    this.dropDown.el.on(
      'click',
      function (e) {
        if ($(e.target).hasClass('ca-ui-iconselect_item')) {
          this.setActiveIconItem($(e.target));
          if (this.options.onSelect) { this.options.onSelect(this.options.icon, this.options.iconName); }
          this.dropDown.hide();
        }
      }.bind(this)
    );

    if (!IconSelect.icons) {
      $.ajax(CAUI.basePath + '/assets/json/ui/2.0/icons.json')
        .done(
          function (icons) {
            IconSelect.icons = icons;
            this.initIconList(icons);
          }.bind(this)
        )
        .fail(function () {
          alert('Cannot load icons');
        });
    } else this.initIconList(IconSelect.icons);

    this.dropDown.shim.on('click', function () {
      this.clearIconFiltering();
    }.bind(this));
  }

  initIconList (icons) {
    console.log(icons);
    // Common
    icons.common.forEach(
      function (icon) {
        const item = this.createIconItem(icon);
        this.commonList.append(item);
      }.bind(this)
    );

    // All
    icons.all.forEach(
      function (icon) {
        const item = this.createIconItem(icon);
        this.allList.append(item);
      }.bind(this)
    );
  }

  filterAssets (query) {
    if (query === '') {
      this.commonList.find('li').show();
      this.allList.find('li').show();
    } else {
      this.commonList.find(`li:not([data-iconname^="${query}"])`, `li:not([data-iconname$="${query}"])`).hide();
      this.commonList.find(`li[data-iconname^="${query}"]`, `li[data-iconname$="${query}"]`).show();
      this.allList.find(`li:not([data-iconname^="${query}"])`, `li:not([data-iconname$="${query}"])`).hide();
      this.allList.find(`li[data-iconname^="${query}"]`, `li[data-iconname$="${query}"]`).show();
    }
  }

  setActiveIconItem (iconItem) {
    if (this.activeItem) this.activeItem.removeClass('active');

    this.activeItem = iconItem;
    this.activeItem.addClass('active');
    this.options.icon = this.activeItem.data('icon');
    this.options.iconName = this.activeItem.data('iconname');

    this.button.setIcon(this.options.iconName);
  }

  createIconItem (icon) {
    const item = $(
      '<li class="ca-ui-iconselect_item fa fa-' +
        icon.key +
        '" data-icon="' +
        icon.code +
        '" data-iconname="' +
        icon.key +
        '"></li>'
    );
    if (icon.key === this.options.icon) this.setActiveIconItem(item);
    return item;
  }

  setIcon (icon) {
    this.commonList.find('li[data-icon="' + icon + '"]').each(
      function (i, item) {
        this.setActiveIconItem($(item));
      }.bind(this)
    );

    this.allList.find('li[data-icon="' + icon + '"]').each(
      function (i, item) {
        this.setActiveIconItem($(item));
      }.bind(this)
    );
  }

  static initOptions (options) {
    options.button = { label: 'Change', icon: options.icon };
    return options;
  }

  clearIconFiltering () {
    this.searchbox.val('').change();
    this.commonList.find('li').show();
    this.allList.find('li').show();
  }
}
